// removed by extract-text-webpack-plugin
module.exports = {"Logo":"_2zNchjEvQi4XmojJgjT4EZ _3LkWj7OWRUqDNUQbemA88d","Content":"_3CyilcW8ncMsFiAyJD5LD3 _2Pv7Jl1le9p9b4gi5yTJzC","Footer":"_2x_cv5X1wVCNwCUlfyJmMh _122pszWI92_7aZNQfBgG5J _1FL9MexFCBWUtchy9KsrIa"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Logout/styles.css
// module id = 660
// module chunks = 0